/**
 * My(사용자 개인화) API
 */
import { api } from "@/redworks/api/index";

const MY_PATH = {
  CHANGE_MY_PWORD: "/v1/my/password", // 내 비밀번호 변경 API
};

const MY_RST_CD = {
  SUCCESS: 200,
  UNAUTHORIZED: 401, // 미인증 / 인증기간 만료
  NON_PERMISSION: 403, // API 권한 없음
};

// 나의 비밀번호 변경 API
function $updateMyPassword(params,) {
  return api.put(MY_PATH.CHANGE_MY_PWORD, params);
}

export {
  MY_RST_CD,
  $updateMyPassword,
};
